import React from "react";
import "./AboutUsEkibimiz.css";

const leaders = [
  {
    photo: "/team/tugce-nur-ercetin.svg",
    name: "Tuğçe Nur Erçetin",
    info: ["Psikolog", "Co-founder"],
    role: "Project Manager",
    cardVariant: "purple",
  },
  {
    photo: "/team/eda-nur-ercetin.svg",
    name: "Eda Nur Erçetin",
    info: ["Dil ve Konuşma Terapisi YL", "Co-founder"],
    role: "CEO",
    cardVariant: "purple",
  },
  {
    photo: "/team/haldun-bozkurt.svg",
    name: "Haldun Bozkurt",
    info: ["Telekomünikasyon Mühendisi", "YL Mezunu"],
    role: "CTO & Backend Developer",
    cardVariant: "navy",
  },
];

const members = [
  {
    photo: "/team/talha-guller.svg",
    name: "Talha Güller",
    info: ["Bilgisayar Mühendisi", "TBD Bilişim Derneği", "Üyesi"],
    role: "Full-Stack Yazılım Geliştirici",
    cardVariant: "navy",
  },
  {
    photo: "/team/nilufer-yildirim.svg",
    name: "Nilüfer Yıldırım",
    info: ["Pratisyen Hekim", "Enformasyon YL"],
    role: "Bilimsel İçerik Koordinatörü",
    cardVariant: "navy",
  },
  {
    photo: "/team/sevim-yildirim.svg",
    name: "Sevim Yıldırım",
    info: ["Mühendis & Satış", "Direktörü"],
    role: "Satış Koordinatörü",
    cardVariant: "navy",
  },
  {
    photo: "/team/rabia-durmus.svg",
    name: "Rabia Durmuş",
    info: ["Endüstri Mühendisi", "& İBB Strateji Birimi", "Sorumlusu"],
    role: "Operasyon Ekip Üyesi",
    cardVariant: "navy",
  },
  {
    photo: "/team/sevval-cengizli.svg",
    name: "Şevval Cengizli",
    info: ["Dil ve Konuşma", "Terapisti & Atlas Üni.", "Araştırma Gör."],
    role: "Arge Koordinatörü",
    cardVariant: "navy",
  },
  {
    photo: "/team/zuleyha-demirci.svg",
    name: "Züleyha Demirci",
    info: ["İşletme Yönetimi", "Uzmanı"],
    role: "Finans Koordinatörü",
    cardVariant: "navy",
  },
];

const TeamCard = ({ member }) => (
  <div className={`ekip-card ekip-card-${member.cardVariant}`}>
    <div className="ekip-photo-wrapper">
      <img
        src={member.photo}
        alt={member.name}
        className="ekip-photo"
        onError={(e) => {
          e.target.style.visibility = "hidden";
        }}
      />
    </div>
    <div className="ekip-card-body">
      <p className="ekip-name">{member.name}</p>
      <div className="ekip-info">
        {member.info.map((line, i) => (
          <p key={i} className="ekip-info-line">
            {line}
          </p>
        ))}
      </div>
      <span className="ekip-role-badge">{member.role}</span>
    </div>
  </div>
);

const AboutUsEkibimiz = () => {
  return (
    <div className="ekibimiz-wrapper">
      <div className="ekibimiz-container">
        <p className="ekibimiz-baslik">Ekibimiz</p>

        <div className="ekibimiz-row ekibimiz-row-top">
          {leaders.map((member, index) => (
            <TeamCard member={member} key={`leader-${index}`} />
          ))}
        </div>

        <div className="ekibimiz-row ekibimiz-row-bottom">
          {members.map((member, index) => (
            <TeamCard member={member} key={`member-${index}`} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutUsEkibimiz;